export enum VolumeUnits {
  CubicMetersDay,
  BarrelsDay,
}
